import { CreateManyProductComponents } from "../../Models/ProductComponent";
import api from "../axios";

export const productComponentService = {
  createMany: async (data: CreateManyProductComponents) => {
    const response = await api.post('/product-component/bulk', data);
    return response.data;
  },

  delete: async (id: string) => {
    const response = await api.delete(`/product-component/${id}`);
    return response.data;
  }
};
